import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-wams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-wams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { Validators } from "@angular/forms";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { AppControllerService } from "../../../../app-controller.service";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { CreateApplicationDetailsWamsConstants } from "./create-application-details-wams.constants";
import { CompareDatesUtil } from "../../../../shared/utils/date-field-validator.utils";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { DatePipe } from "@angular/common";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
let CreateApplicationDetailsWamsComponent = class CreateApplicationDetailsWamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    datePipe;
    appControllerService;
    changeDetectorRefs;
    searchApplicationsService;
    detailsForm;
    validationMessages = CreateApplicationDetailsWamsConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    descriptionFormControlName = CreateApplicationDetailsWamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsWamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    clientReferenceNumberFormControlName = CreateApplicationDetailsWamsConstants.CLIENT_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    applicantTelecommunicationLicenseNumberFormControlName = CreateApplicationDetailsWamsConstants.APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_FORM_CONTROL_NAME;
    scopeOfWorkFormControlName = CreateApplicationDetailsWamsConstants.SCOPE_OF_WORK_FORM_CONTROL_NAME;
    estimatedConstructionCostFormControlName = CreateApplicationDetailsWamsConstants.ESTIMATED_CONSTRUCTION_COST_FORM_CONTROL_NAME;
    applicationFeeFormControlName = CreateApplicationDetailsWamsConstants.APPLICATION_FEE_FORM_CONTROL_NAME;
    constructionPeriodInWeeksFormControlName = CreateApplicationDetailsWamsConstants.CONSTRUCTION_PERIOD_FORM_CONTROL_NAME;
    proposedStartDateFormControlName = CreateApplicationDetailsWamsConstants.PROPOSED_START_DATE_FORM_CONTROL_NAME;
    proposedEndDateFormControlName = CreateApplicationDetailsWamsConstants.PROPOSED_END_DATE_FORM_CONTROL_NAME;
    laneClosureIsRequiredFormControlName = CreateApplicationDetailsWamsConstants.LANE_CLOSURE_IS_REQUIRED_FORM_CONTROL_NAME;
    laneClosureExtentFormControlName = CreateApplicationDetailsWamsConstants.LANE_CLOSURE_EXTENT_FORM_CONTROL_NAME;
    constructionPeriodUnitsFormControlName = CreateApplicationDetailsWamsConstants.CONSTRUCTION_PERIOD_UNITS_FORM_CONTROL_NAME;
    electricalServicesFormControlName = CreateApplicationDetailsWamsConstants.ELECTRICAL_SERVICES_FORM_CONTROL_NAME;
    servicesFormControlName = CreateApplicationDetailsWamsConstants.SERVICES_FORM_CONTROL_NAME;
    applicationTypeLabel = CreateApplicationDetailsWamsConstants.APPLICATION_TYPE_LABEL;
    descriptionLabel = CreateApplicationDetailsWamsConstants.DESCRIPTION_LABEL;
    clientReferenceNumberLabel = CreateApplicationDetailsWamsConstants.CLIENT_REFERENCE_NUMBER_LABEL;
    applicantTelecommunicationLicenseNumberLabel = CreateApplicationDetailsWamsConstants.APPLICANT_TELECOMMUNICATION_LICENCE_NUMBER_LABEL;
    scopeOfWorkFormLabel = CreateApplicationDetailsWamsConstants.SCOPE_OF_WORK_LABEL;
    estimatedConstructionCostLabel = CreateApplicationDetailsWamsConstants.ESTIMATED_CONSTRUCTION_COST_LABEL;
    applicationFeeLabel = CreateApplicationDetailsWamsConstants.APPLICATION_FEE_LABEL;
    constructionPeriodLabel = CreateApplicationDetailsWamsConstants.CONSTRUCTION_PERIOD_LABEL;
    proposedStartDateLabel = CreateApplicationDetailsWamsConstants.PROPOSED_START_DATE_LABEL;
    proposedEndDateLabel = CreateApplicationDetailsWamsConstants.PROPOSED_END_DATE_LABEL;
    laneClosureIsRequiredLabel = CreateApplicationDetailsWamsConstants.LANE_CLOSURE_IS_REQUIRED_LABEL;
    laneClosureExtentLabel = CreateApplicationDetailsWamsConstants.LANE_CLOSURE_EXTENT_LABEL;
    constructionPeriodUnitsLabel = CreateApplicationDetailsWamsConstants.CONSTRUCTION_PERIOD_UNITS_LABEL;
    servicesLabel = CreateApplicationDetailsWamsConstants.SERVICES_LABEL;
    servicesDropdownSettings = CreateApplicationDetailsWamsConstants.SERVICES_DROPDOWN_SETTINGS;
    electricalServicesLabel = CreateApplicationDetailsWamsConstants.ELECTRICAL_SERVICES_LABEL;
    // Please do not rename variables below
    showscopeOfWork = true;
    showclientReferenceNumber = true;
    showapplicantTelecommunicationLicenseNumber = true;
    showapplicationFee = true;
    showestimatedConstructionCost = true;
    showproposedStartDate = true;
    showproposedEndDate = true;
    showlaneClosureIsRequired = true;
    showlaneClosureExtent = true;
    showconstructionPeriodUnits = true;
    showservices = true;
    showconstructionPeriod = true;
    showelectricalServices = true;
    applicationTypes = [];
    zones = [];
    yesNoOptions = [];
    laneClosureExtentOptions = [];
    electricalServicesOptions = [];
    constructionPeriodUnitsOptions = [
        { code: "Days", value: "Days" },
        { code: "Months", value: "Months" },
        { code: "Weeks", value: "Weeks" },
        { code: "Years", value: "Years" }
    ];
    servicesOptions = [];
    applicationTypeOptions = [];
    dateValidationError = CreateApplicationDetailsWamsConstants.DATE_VALIDATION_ERROR;
    selectedApplicationDetailsWamsSubscription;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, datePipe, appControllerService, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.datePipe = datePipe;
        this.appControllerService = appControllerService;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        this.getLookups();
        this.getMetadata();
    }
    loadMetadata(stepMeta) {
        if (stepMeta && stepMeta.hasOwnProperty("applicationDetailsFields")) {
            const detailsFieldsOptions = stepMeta.applicationDetailsFields;
            this.setRequiredFieldsFromStepMeta(detailsFieldsOptions);
            this.showOrHideApplicationDetailsFields(detailsFieldsOptions);
            this.detailsForm.updateValueAndValidity();
            this.changeDetectorRefs.detectChanges();
        }
    }
    verifyProposedDates(formControlName) {
        // checks if the startDate is >= endDate
        CompareDatesUtil.verifyProposedDates(this.detailsForm, this.proposedStartDateFormControlName, this.proposedEndDateFormControlName, formControlName, this.appControllerService);
    }
    initForm() {
        const form = this.aflaModuleStrategyService.form.get("detailsForm");
        this.detailsForm = form;
        this.detailsForm.enable();
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and (name eq 'LaneClosureExtent' or name eq 'ElectricalServices' or name eq 'ApplicationType' or name eq 'Services')`,
        };
        this.applicationCreateService
            .getLookupsObservable(params)
            .subscribe((response) => this.onGetLookupsCompleted(response), (error) => {
            this.appControllerService.handleServerErrorMessage(CreateApplicationDetailsWamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetLookupsCompleted(response) {
        this.laneClosureExtentOptions = [];
        this.electricalServicesOptions = [];
        this.applicationTypeOptions = [];
        this.servicesOptions = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "LaneClosureExtent") {
                    this.laneClosureExtentOptions.push(JSON.parse(item.content));
                }
                if (item.name === "ElectricalServices") {
                    this.electricalServicesOptions.push(JSON.parse(item.content));
                }
                if (item.name === "Services") {
                    this.servicesOptions.push(JSON.parse(item.content));
                }
                if (item.name === "ApplicationType") {
                    this.applicationTypeOptions.push(JSON.parse(item.content));
                }
            });
        }
        this.laneClosureExtentOptions.sort((a, b) => a.value.localeCompare(b.value));
        this.electricalServicesOptions.sort((a, b) => a.value.localeCompare(b.value));
        this.applicationTypeOptions.sort((a, b) => a.value.localeCompare(b.value));
        this.servicesOptions.sort((a, b) => a.value.localeCompare(b.value));
        this.yesNoOptions = [];
        // tslint:disable-next-line:forin
        for (const yesnoenumKey in SharedConstants.YES_NO_ENUM) {
            this.yesNoOptions.push(SharedConstants.YES_NO_ENUM[yesnoenumKey]);
        }
        this.changeDetectorRefs.detectChanges();
        this.subscribeToSelectedApplication();
    }
    subscribeToSelectedApplication() {
        if (this.aflaModuleStrategyService.previousApplication) {
            this.setApplicationDetails(this.aflaModuleStrategyService.previousApplication);
        }
        this.selectedApplicationDetailsWamsSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        // checks the application has application details set
        this.detailsForm.reset();
        if (application.description) {
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        }
        if (application.scopeOfWork) {
            this.detailsForm.get(this.scopeOfWorkFormControlName).setValue(application.scopeOfWork);
        }
        if (application.clientReferenceNumber) {
            this.detailsForm.get(this.clientReferenceNumberFormControlName).setValue(application.clientReferenceNumber);
        }
        if (application.licenceNumber) {
            this.detailsForm.get(this.applicantTelecommunicationLicenseNumberFormControlName).setValue(application.licenceNumber);
        }
        if (application.applicationFee) {
            this.detailsForm.get(this.applicationFeeFormControlName).setValue(application.applicationFee);
        }
        if (application.estimatedCost) {
            this.detailsForm.get(this.estimatedConstructionCostFormControlName).setValue(application.estimatedCost);
        }
        if (application.proposedStartDate) {
            this.detailsForm.get(this.proposedStartDateFormControlName).setValue(this.datePipe.transform(application.proposedStartDate, "yyyy-MM-dd"));
        }
        if (application.proposedEndDate) {
            this.detailsForm.get(this.proposedEndDateFormControlName).setValue(this.datePipe.transform(application.proposedEndDate, "yyyy-MM-dd"));
        }
        if (application.laneClosureRequired) {
            this.detailsForm.get(this.laneClosureIsRequiredFormControlName).setValue(application.laneClosureRequired);
        }
        if (application.laneClosureExtent) {
            this.detailsForm.get(this.laneClosureExtentFormControlName).setValue(application.laneClosureExtent);
        }
        if (application.constructionPeriod) {
            this.detailsForm.get(this.constructionPeriodInWeeksFormControlName).setValue(application.constructionPeriod);
        }
        this.applicationTypeOptions.forEach(item => {
            if (item.value === application.applicationType) {
                this.detailsForm.get(this.applicationTypeFormControlName).setValue(item.value);
            }
        });
        this.constructionPeriodUnitsOptions.forEach(item => {
            if (item.value === application.constructionPeriodUnits) {
                this.detailsForm.get(this.constructionPeriodUnitsFormControlName).setValue(item.value);
            }
        });
        this.electricalServicesOptions.forEach(item => {
            if (item.value === application.electricalServices) {
                this.detailsForm.get(this.electricalServicesFormControlName).setValue(item.value);
            }
        });
        const selectedServices = [];
        application.applicationServices.forEach(applicationService => {
            this.servicesOptions.forEach(serviceOption => {
                if (serviceOption.value === applicationService.service) {
                    selectedServices.push(serviceOption);
                }
            });
        });
        this.detailsForm.get(this.servicesFormControlName).setValue(selectedServices);
    }
    setRequiredFieldsFromStepMeta(applicationDetailsFields) {
        for (const [formControlName, applicationDetailsFieldsOptions] of Object.entries(applicationDetailsFields)) {
            if (applicationDetailsFieldsOptions.required) {
                this.detailsForm.get(`${formControlName}`).addValidators(Validators.required);
                this.detailsForm.get(`${formControlName}`).updateValueAndValidity();
            }
            if (applicationDetailsFieldsOptions.required === false) {
                this.detailsForm.get(`${formControlName}`).clearValidators();
                this.detailsForm.get(`${formControlName}`).updateValueAndValidity();
            }
            this.detailsForm.updateValueAndValidity();
        }
    }
    showOrHideApplicationDetailsFields(applicationDetailsFields) {
        for (const [formControlName, applicationDetailsFieldsOptions] of Object.entries(applicationDetailsFields)) {
            const control = this.detailsForm.get(formControlName);
            if (!control)
                return;
            const fieldsOptions = applicationDetailsFieldsOptions;
            if (!fieldsOptions)
                return;
            this.detailsForm.get(`${formControlName}`).clearValidators();
            this.detailsForm.get(`${formControlName}`).updateValueAndValidity();
            this[`show${formControlName}`] = applicationDetailsFieldsOptions.visible;
            this.detailsForm.updateValueAndValidity();
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: DatePipe },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationDetailsWamsComponent = __decorate([
    Component({
        selector: "app-create-application-details-wams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsWamsComponent);
export { CreateApplicationDetailsWamsComponent };
